import { type FC, memo } from 'react';

import { MultiViewCampaignSection, type CampaignSectionProps } from '../MultiViewCampaignSection';
import { getStrategy } from '../variants/strategies';
import { GenericErrorBoundary } from '../../../../shared/components/ErrorBoundaries/GenericErrorBoundary';
import type { ErrorCategory } from '../../../../shared/components/ErrorBoundaries/ErrorUtils';
import { MULTI_VIEW_MODE } from '../../../../constants';
import { SECTION_NAMES } from '@repo/common';

/** Maps section names to strategy registry keys */
const sectionToStrategyKey: Record<string, string> = {
  [SECTION_NAMES.PRIZE_POP]: 'prize-pop',
  [SECTION_NAMES.TOURNAMENTS]: 'tournaments',
  [SECTION_NAMES.REBATE]: 'rebate',
};

interface IMultiViewCampaignProps extends CampaignSectionProps {}

const MultiViewCampaign: FC<IMultiViewCampaignProps> = ({ data, isActive = false }) => {
  const strategyKey = sectionToStrategyKey[data.name];
  const strategy = strategyKey ? getStrategy(strategyKey) : undefined;

  if (!strategy) return null;

  const errorType = strategy.type as ErrorCategory;

  return (
    <GenericErrorBoundary
      type={errorType}
      identifier={`${data.name}-section`}
      fallback={(error, reset) =>
        strategy.renderFallback?.({
          sectionName: data.name,
          error,
          onRetry: reset,
          viewMode: MULTI_VIEW_MODE,
        }) || null
      }
    >
      <MultiViewCampaignSection data={data} isActive={isActive} strategy={strategy} />
    </GenericErrorBoundary>
  );
};

export default memo(MultiViewCampaign);
